import React from "react";
import Alert from "../../../../_components/Alert";
import Button from "../../../../_components/Button";
import LoadingInput from "../../../../_components/LoadingInput";
import { getConfig, updateConfig } from "../../../../api/sales";

export default (props) => {
  const ref = React.useRef(null);
  const [config, setConfig] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [alert, setShowAlert] = React.useState(false);
  function goBack() {
    window.history.back();
  }

  function onChange(e) {
    setConfig({
      ...config,
      [e.target.name]: e.target.value,
    });
  }
  function onSave() {
    setLoading(true);
    updateConfig(config)
      .then((x) => {
        setShowAlert(true);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .finally(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
  }
  function init() {
    getConfig().then((data) => setConfig(data));
  }
  React.useEffect(init, [ref.current]);
  return (
    <div className="container" ref={ref}>
      <Alert
        type="success"
        show={alert}
        message="Configurações atualizadas!"
        timeout={30000}
      />
      Novas configurações
      <div className="row">
        <div className="col-md-4">
          <LoadingInput
            onChange={onChange}
            name="automatic_print"
            label="Impressão automática da venda ao finalizar a venda?"
            as="select"
            loading={loading}
          >
            <option selected={config.automatic_print == true} value={true}>
              Sim
            </option>
            <option selected={config.automatic_print == false} value={false}>
              Não
            </option>
          </LoadingInput>
        </div>
        <div className="col-md-4">
          <LoadingInput
            name="default_print_orientation"
            onChange={onChange}
            loading={loading}
            label="Orientação padrão da impressão"
            as="select"
          >
            <option
              selected={config.default_print_orientation == "1"}
              value={"1"}
            >
              Retrato
            </option>
            <option
              selected={config.default_print_orientation == "2"}
              value={"2"}
            >
              Paisagem
            </option>
          </LoadingInput>
        </div>
        <div className="col-md-4">
          <LoadingInput
            name="print_layout"
            onChange={onChange}
            loading={loading}
            label="Formato padrão de impressão da venda"
            as="select"
          >
            <option selected={config.print_layout == "1"} value={"1"}>
              A4
            </option>
            <option selected={config.print_layout == "2"} value={"2"}>
              80x80 (Não Fiscal)
            </option>
          </LoadingInput>
        </div>
        <div className="col-md-4">
          <LoadingInput
            loading={loading}
            name="return_products_to_stock"
            onChange={onChange}
            label="Retornar produtos ao estoque quando cancelar venda?"
            as="select"
          >
            <option
              selected={config.return_products_to_stock == true}
              value={true}
            >
              Sim
            </option>
            <option
              selected={config.return_products_to_stock == false}
              value={false}
            >
              Não
            </option>
          </LoadingInput>
        </div>
        <div className="col-md-4">
          <LoadingInput
            name="register_user_on_sale"
            onChange={onChange}
            loading={loading}
            label="Habilitar cadastro de cliente na venda?"
            as="select"
          >
            <option
              selected={config.register_user_on_sale == true}
              value={true}
            >
              Sim
            </option>
            <option
              selected={config.register_user_on_sale == false}
              value={false}
            >
              Não
            </option>
          </LoadingInput>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between py-3">
            <Button
              disabled={loading}
              onClick={goBack}
              className="text-danger"
              as="text"
            >
              Cancelar
            </Button>
            <Button disabled={loading} onClick={onSave}>
              Salvar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Sales/Config/index.jsx